<template>
    <div class="pa-0">
        <c-drawer-header
            title  = "Termine"
            icon   = "fas fa-bell"
            filter = "true"
            @close = "onClose"
            @arrow = "onArrow"
        />

        <v-row class="mt-0">
            <v-col class="crm-reminder-col">
                <v-text-field hide-details append-icon="fas fa-search" class="pl-4 pr-5 pt-2 pb-1"/>
                <v-layout row wrap  class="crm-reminder-list" :style="'height: ' + height + 'px'">
                    <div v-if="reminder.length === 0" class="crm-no-messages">
                        Keine Erinnerungen
                    </div>
                    <div v-if="reminder.length > 0" class="w-100">
                            <crm-reminder-entry
                                v-for="(reminder, index) in reminder" :key="index"
                                :reminder="reminder"
                                v-model="menuOpen"
                                class="mb-4"
                            />
                    </div>
                </v-layout>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CrmReminderEntry from "@/modules/crm/components/nav/CrmReminderEntry";
import Inc from "@/modules/inc/service/Inc.js";
import CDrawerHeader from "@/modules/core/components/utils/CDrawerHeader";

export default {
    name: "CrmReminderDrawer",

    components: {
        CDrawerHeader,
        CrmReminderEntry
    },

    data: () => ({
        menuOpen: false,
        height  : 600,
    }),

    computed: {
        reminder () {
            return this.$store.getters.top;
        },
    },

    created() {
        this.load();
        window.addEventListener("resize", this.onResize);
        this.$bus.$on(Inc.events.journal, this.load);
    },

    beforeDestroy() {
        this.$bus.$off(Inc.events.journal, this.load);
        window.removeEventListener("resize", this.onResize);
    },

    methods: {
        load() {
            this.$store.dispatch('getReminderByUser');
        },

        async loadTotal() {
            await this.$store.dispatch('getTotalMessagesByUser');
        },

        onResize () {
            this.height = window.innerHeight - 100;
        },

        onClose () {
            this.$emit("close");
        },

        onArrow (value) {
            this.$emit("position", value);
        },
    }
}

</script>

<style scoped>

.crm-reminder-list {
    width: calc(100% - 10px);
    min-height: 140px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: white;
    padding: 0;
    padding-left: 10px;
    margin-top: 10px;
}

.crm-reminder-col {
    min-width: 100%;
    max-width: calc(100% - 55px);
    padding: 0;
}

div::-webkit-scrollbar {
    width: 5px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3)!important;
    border-radius: 10px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
}


.crm-reminder-info p {
    font-size: 9pt;
    font-weight: normal;
    margin-bottom: 0;
}


.crm-no-messages {
    text-align: center;
    padding-top: 45px;
    font-size: 18px;
}

</style>
